import React, { useEffect } from 'react';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';

import { CloneMentorshipProgramProvider, useCloneMentorshipProgram } from './state/context';
import { CloneMentorshipProgramActionType, CloneMentorshipProgramWizardStep } from './state/types';

import CloneMentorshipProgramModal from './clone-mentorship-program-modal';

type CloneMentorshipProgramWizardProps = {
  show: boolean;
  onClose: (payload?: { didStartClone?: boolean }) => void;
  sourceProgramId?: string;
  program?: MentoringProgram;
};

const WizardInitializer = ({
  show,
  onClose,
  sourceProgramId,
  program,
}: CloneMentorshipProgramWizardProps) => {
  const { dispatch } = useCloneMentorshipProgram();
  const prevShow = React.useRef(show);

  useEffect(() => {
    if (show && !prevShow.current && sourceProgramId) {
      dispatch({
        type: CloneMentorshipProgramActionType.SET_SOURCE_PROGRAM,
        payload: {
          ...program,
        } as MentoringProgram,
      });

      dispatch({
        type: CloneMentorshipProgramActionType.SET_STEP,
        payload: CloneMentorshipProgramWizardStep.CONFIG,
      });
    } else if (!show && prevShow.current) {
      dispatch({ type: CloneMentorshipProgramActionType.RESET_WIZARD });
    }
    prevShow.current = show;
  }, [show, sourceProgramId, program, dispatch]);

  return <CloneMentorshipProgramModal show={show} onClose={onClose} />;
};

const CloneMentorshipProgramWizard = (props: CloneMentorshipProgramWizardProps) => (
  <CloneMentorshipProgramProvider>
    <WizardInitializer {...props} />
  </CloneMentorshipProgramProvider>
);

export default CloneMentorshipProgramWizard;
